module.exports = __webpack_public_path__ + "static/media/Change-Password.7c85e713.svg";